module.exports = __webpack_public_path__ + "img/product_44.faf0ccd.webp";